/** Only same-app paths are accepted as post-login redirects (prevents open redirects). */
export function safeRedirectPath(value: string | null): string {
  if (!value?.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return "/";
  return value;
}
